import { z } from "zod";

import { accountSchema } from "./account";
import { chatMessageSchema } from "./chat-message";
import { dateSchema } from "./utils";

const messageExpirationOptions = [604800, 1209600, 2592000, 7776000];

enum MessageExpirationValues {
  "SEVEN_DAYS" = messageExpirationOptions[0],
  "FOURTEEN_DAYS" = messageExpirationOptions[1],
  "THIRTY_DAYS" = messageExpirationOptions[2],
  "NINETY_DAYS" = messageExpirationOptions[3],
}

const chatSchema = z.object({
  accepted: z.boolean().optional().catch(false),
  account: accountSchema,
  chat_type: z.enum(["channel", "direct"]).optional().catch("direct"),
  created_at: dateSchema,
  created_by_account: z.string(),
  discarded_at: dateSchema.nullable().catch(null),
  id: z.string(),
  last_message: chatMessageSchema.optional().nullable().catch(null),
  latest_read_message_by_account: z
    .array(
      z.object({
        id: z.string(),
        date: dateSchema,
      }),
    )
    .optional()
    .nullable()
    .catch(null),
  latest_read_message_created_at: dateSchema.optional().nullable().catch(null),
  message_expiration: z.nativeEnum(MessageExpirationValues).catch(0),
  unread: z.number().catch(0),
  updated_at: dateSchema,
});

type Chat = z.infer<typeof chatSchema>;

export {
  chatSchema,
  type Chat,
  MessageExpirationValues,
  messageExpirationOptions,
};
